import React from "react";
import { useNavigate } from "react-router-dom";
import why from "../Assets/Why Every Business Needs a Digital Marketing Agency in 2026.png";

const AboutWhy = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full py-12 sm:py-16 px-4 sm:px-6 lg:px-16 bg-[#f5f7fb]">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
            Why Every Business Needs a{" "}
            <span className="text-[#f99728]">
              Digital Marketing Agency
            </span>{" "}
            in 2026
          </h2>
        </div>

        {/* MAIN LAYOUT */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10">

          {/* LEFT IMAGE */}
          <div className="flex items-center justify-center">
            <div className="lg:sticky lg:top-10 w-full">
              <img
                src={why}
                alt="Digital Marketing"
                className="w-full rounded-2xl shadow-xl object-cover"
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="flex flex-col justify-between">

            {/* TEXT */}
            <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
              In today’s fast-evolving digital landscape, businesses can no longer rely solely on traditional marketing methods. As we move into 2026, having a strong online presence is not just an option—it is a necessity. This is where a digital marketing agency like Growth Loom Digital plays a crucial role in helping businesses scale, compete, and generate measurable results.
            </p>

            {/* BUTTON */}
            <div className="mt-6 sm:mt-8">
              <button
                onClick={() => navigate("/WhyDigital")}
                className="bg-[#f99728] hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition duration-300 w-full sm:w-auto"
              >
                Learn More →
              </button>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutWhy;